import React from 'react'
import StateManagedSelect from 'react-select'
import ReactSelect from 'react-select'

const selectStyles = {
  control: provided => ({
    ...provided,
    background: '#fff',
    border: '1px #E1E6F5 solid',
    marginBottom: '16px',
    borderRadius: '12px',
    minHeight: '56px',
    height: '56px',
    fontSize: '1.15rem',
    lineHeight: '1.4',
    boxShadow:
      'inset 0px 3px 2px rgba(0, 0, 0, 0.02), inset 0px 2px 1px rgba(0, 0, 0, 0.06)',
  }),

  placeholder: (provided, _state) => ({
    ...provided,
    color: '#6e7789',
    textAlign: 'left',
  }),

  valueContainer: (provided, _state) => ({
    ...provided,
    height: '54px',
    padding: '0 20px',
  }),

  input: (provided, _state) => ({
    ...provided,
    padding: 0,
    margin: 0,
  }),

  indicatorSeparator: _state => ({
    display: 'none',
  }),

  indicatorsContainer: (provided, _state) => ({
    ...provided,
    height: '54px',
  }),

  option: provided => ({
    ...provided,
    fontSize: '1rem',
    textAlign: 'left',
    padding: '4px 20px',
  }),
}

const Select: StateManagedSelect = props => (
  <ReactSelect styles={selectStyles} {...props} />
)

export default Select
